import { createFilter } from 'react-select';

// react-select's default filter also matches option.value (the internal field name),
// so typing "ad" would match every adn_* metric.
export const filterByLabelOnly = createFilter({ stringify: option => option.label });
